import classNames from 'classnames';
import { ArticleContent } from 'components/Article/ArticleContent/ArticleContent';
import { ArticleFooter } from 'components/Article/ArticleFooter/ArticleFooter';
import { ArticleHeader } from 'components/Article/ArticleHeader';
import ListGroup from 'react-bootstrap/ListGroup';
import { OpinionModel } from '../Opinion.hooks';

export type OpinionItemProps = {
  canRead: boolean;
  isShowStock?: boolean;
  isShowDirection?: boolean;
} & OpinionModel;

export const OpinionItem = ({ canRead, isShowStock, isShowDirection, ...article }: OpinionItemProps) => {
  return (
    <ListGroup.Item className={classNames('py-3', { blur: !canRead })}>
      <ArticleHeader isShowStock={isShowStock} isShowDirection={isShowDirection} {...article} />
      <ArticleContent {...article} />
      <ArticleFooter {...article} />
    </ListGroup.Item>
  );
};
